import Exception from "@/core/exceptions/Exception";
import DefaultExceptionTypes from "@/core/exceptions/DefaultExceptionTypes";
import { ScreeningReportsResponse } from "@/core/customers/entities/ScreeningReports";
import ScreeningReportsRepository from "@/core/customers/repositories/ScreeningReportsRepository";

export default class GetScreeningReportsUseCase {
  constructor(
    private readonly screeningReportsRepository: ScreeningReportsRepository
  ) {}

  /**
   * Executes the get screening reports use case.
   *
   * @param businessKey - The business key of the customer
   * @returns A promise resolving with ScreeningReportsResponse
   * @throws {Exception} If an exception occurs during execution
   */
  async execute(businessKey: string): Promise<ScreeningReportsResponse> {
    if (!businessKey || businessKey.trim() === "") {
      const exception: Exception<unknown, DefaultExceptionTypes> = {
        type: DefaultExceptionTypes.BAD_REQUEST,
        message: "Business key is required",
      };
      throw exception;
    }

    try {
      const apiResponse = await this.screeningReportsRepository.getScreeningReports(
        businessKey
      );
      
      // Map API response to domain model if needed
      // For now, assuming repository returns already mapped data
      return apiResponse;
    } catch (e) {
      if ((e as Exception).type) {
        throw e;
      } else {
        throw { type: DefaultExceptionTypes.UNKNOWN_ERROR, body: e };
      }
    }
  }
}

